const routes = {
  login: "/login",
  signup: "/signup",
  home: "/home",
  ainqa: "/ainqa",
  messageCatalog: "/messageCatalog",
  repository: "/repository"
};

export default routes;